module.exports = __webpack_public_path__ + "assets/77e39e93a71f68da97359a65c98829b6.png";